<!--
  Override-modal template. Mirrors the legacy
  `efileElements/overrides/override-modal-tpl.html` UX (entity-form-line
  title, manual / system-value radios, override-history table, lock
  banner, save action) but rebuilt with the standardized header-actions
  pattern + custom button classes per the migration rules.
-->
<div class="override-modal" [class.is-minimised]="minimise">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ rowData?.ENTITY }} - {{ rowData?.FORM }} - {{ rowData?.LINE_NO }}
    </h3>
    <div class="header-actions">
      <i class="fa hoverable"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px;"
         (click)="minimise = !minimise"
         title="{{ minimise ? 'Restore' : 'Minimise' }}"></i>
      <i class="fa fa-times hoverable"
         (click)="cancel()"
         title="Close"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    @if (isLocked) {
<div class="lock-banner">
      <i class="fa fa-lock"></i>
      The selected submission is already submitted to IRS or locked.
    </div>
}

    <div class="value-section">
      <div class="value-col">
        <div class="value-row">
          <label class="value-label">Manual Override</label>
          <div class="value-input-row">
            <span class="radio-btn">
              <input type="radio"
                     name="overrideModalAmountType"
                     value="manual"
                     [checked]="amount_type === 'manual'"
                     (change)="setAmountType('manual')"
                     [disabled]="isLocked">
            </span>
            <span class="amount-type-val">{{ manual_value }}</span>
          </div>
        </div>
        <div class="value-row">
          <label class="value-label">System Value</label>
          <div class="value-input-row">
            <span class="radio-btn">
              <input type="radio"
                     name="overrideModalAmountType"
                     value="override"
                     [checked]="amount_type === 'override'"
                     (change)="setAmountType('override')"
                     [disabled]="system_value === '' || isLocked">
            </span>
            <span class="amount-type-val">{{ system_value }}</span>
          </div>
        </div>
        @if (warningMsg) {
<div class="warning-text">{{ warningMsg }}</div>
}
      </div>
      <div class="info-col">
        @if (!overrideValuesSpinner) {
<div>
          @if (amountType === 'manual') {
<div class="hint-text">
            Please select System or Override and click save to clear Diagnostics
          </div>
}
        </div>
}
        @if (overrideValuesSpinner) {
<div class="info-spinner">
          <i class="fa fa-spinner fa-pulse fa-2x"></i>
        </div>
}
      </div>
    </div>

    <div class="element-name-row">
      <span><strong>Element Name:</strong> {{ rowData?.ELEMENT_NAME }}</span>
    </div>

    @if (!overrideValuesSpinner) {
<div class="overide-his-table-wrpr">
      <div class="table-hdr">Override history</div>
      <div class="table-scroll">
        <table class="override-history-table">
          <thead>
            <tr>
              @for (item of overideHisTableData.header; track $index) {
<th>{{ item }}</th>
}
            </tr>
          </thead>
          <tbody>
            @if (!overideHisTableData.body?.length) {
<tr>
              <td [attr.colspan]="overideHisTableData.header?.length || 5"
                  class="no-data">No override history available</td>
            </tr>
}
            @for (item of overideHisTableData.body; track $index; let i = $index) {
<tr>
              <td class="active-cell">
                <input type="radio"
                       name="overrideModalHistoryActive"
                       [checked]="isHistoryRowActive(item)"
                       [disabled]="amountType === 'override' || isLocked"
                       (change)="getActiveVal(item, i)">
                <span>{{ item.IS_ACTIVE }}</span>
              </td>
              <td class="value-cell">
                <div class="value-cell-inner">
                  <span class="value-text">{{ getDisplayValue(item, i) }}</span>
                  @if ((item.ELEMENT_VALUE || '').length >= 50) {
<button class="show-more-btn"
                          type="button"
                         
                          (click)="toggleLoadMore(i)">
                    {{ isLoadMoreExpanded(i) ? 'less' : '...more' }}
                  </button>
}
                </div>
              </td>
              <td>{{ item.CREATED_ON }}</td>
              <td>{{ item.CREATED_BY }}</td>
              <td>{{ item.SOURCE }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
} @else {

      <div class="history-spinner">
        <i class="fa fa-spinner fa-pulse fa-3x"></i>
      </div>
    
}
    
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button"
            type="button"
            [disabled]="isSaving || isLocked"
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="cancel-button"
            type="button"
            (click)="cancel()">Cancel</button>
  </div>
</div>
